import {newLoanConstants, refinanceIncreaseLoanConstants, workflowConstants} from "../_constants";
import {workflowService, LeadService, SessionService, ServiceUtil, metadataService} from "../_services";
import { history } from "../_helpers";
import { newLoanActions } from "./";

export const refinanceIncreaseLoanActions = {
    handleRefinanceMenuClick,
    submitChangeLoanRequest,
    handlePersonalInformationRequest,
    handleFinancialInformationRequest,
    handleFundingRequest,
    handleIncreaseRefinanceNextRequest,
}

function handleRefinanceMenuClick() {
    return dispatch => {
        const branchId = ServiceUtil.getLocalBranchId();
        if(branchId){
            workflowService.startWorkflow(workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW, dispatch, request, failure);
            SessionService.setFundingInformation({
                BranchId:  branchId,
                FundDelivery: metadataService.fundDeliveryType.InStore,
            });
        }else{
            workflowService.startWorkflow(workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW, dispatch, request, failure);
        }
    };

    function request() {

        return {
            type: refinanceIncreaseLoanConstants.REFINANCE_INCREASE_GET_STARTED
        };
    }

    function failure(errorString) {
        return { type: refinanceIncreaseLoanConstants.REFINANCE_INCREASE_GET_STARTED_ERROR, errorString };
    }
}

function submitChangeLoanRequest(data) {
    return dispatch => {
       
        dispatch(loading());
        LeadService.submitChangeLoanRequest(data).then(response => {
            if (response.httpResponseCode !== 200) {
               dispatch(failure(response.message));
            }
            dispatch(success())
            let changeLoanRequest = JSON.parse(sessionStorage.getItem("changeLoanRequest"));
            changeLoanRequest = Object.assign(changeLoanRequest, {refinanceComplete: true});
            sessionStorage.setItem("changeLoanRequest", JSON.stringify(changeLoanRequest));
            dispatch(loading());
            /*history.push("/");*/

        },
        error => {
            dispatch(failure(error));
            dispatch(loading());
        });

       function success() {
           return {
               type: refinanceIncreaseLoanConstants.REFINANCE_LOAN_SUCCESS
           }
       }

       function failure(errorString) {
           return {type: refinanceIncreaseLoanConstants.REFINANCE_LOAN_FAILED, errorString};
       }

       function loading() {
           return {type: refinanceIncreaseLoanConstants.REFINANCE_LOAN_LOADING}
       }
    }
}
function handlePersonalInformationRequest(personalInformation) {
    return dispatch => {
        workflowService.nextStep(dispatch, request, failure, personalInformation);
    };

    function request(personalInformation) {
        SessionService.setPersonalInfo(personalInformation);
        return {
            type: refinanceIncreaseLoanConstants.REFINANCE_LOAN_PERSONAL_INFORMATION_REQUEST,
            personalInformation
        };
    }

    function failure(errorString) {
        return { type: refinanceIncreaseLoanConstants.REFINANCE_LOAN_FAILED, errorString };
    }
}


function handleFinancialInformationRequest(financialInformation) {
    return dispatch => {
        workflowService.nextStep(dispatch, request, failure, financialInformation);
    };

    function request(financialInformation) {
        //SessionService.setFinancialInfo(financialInformation);
        return { type: refinanceIncreaseLoanConstants.REFINANCE_LOAN_FINANCIAL_INFORMATION_REQUEST, financialInformation };
    }

    function failure(errorString) {
        return { type: refinanceIncreaseLoanConstants.REFINANCE_LOAN_FAILED, errorString };
    }

}

function handleFundingRequest(fundingInfo) {
    return dispatch => {
        workflowService.nextStep(dispatch, request, failure, fundingInfo);
    };

    function request(fundingInfo) {   
        fundingInfo = {
            BranchId: fundingInfo.BranchId,
            FundDelivery: fundingInfo.FundDelivery,
            InstantFunding: fundingInfo.InstantFunding
        };
        SessionService.setFundingInformation(fundingInfo);
        return { type: refinanceIncreaseLoanConstants.REFINANCE_LOAN_FUNDING_REQUEST };
    }

    function failure(errorString) {
        return { type: refinanceIncreaseLoanConstants.REFINANCE_LOAN_FAILED, errorString };
    }
}

function handleIncreaseRefinanceNextRequest(){
    return dispatch => {
        workflowService.nextStep(dispatch, request, failure,null);
    };
    function request(){
      return {
        type: refinanceIncreaseLoanConstants.REFINANCE_INCREASE_GET_STARTED,
      };
    }
    function failure(err) {
      return {
        type: refinanceIncreaseLoanConstants.REFINANCE_INCREASE_GET_STARTED_ERROR,err
      };
    }
  }